import { registerView, View, ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import { useCallback } from "react";
import * as React from "react";
import { Alert, Col, Form, Row } from "react-bootstrap";
import ExemptionViewModel from "../../../viewModels/notice/exemption/exemptionViewModel";
import ExemptionNotice from "./notice";
import MethodOfSignature from "../components/methodOfSignature";
import Toolbox from "../components/toolbox";
import LoadingModal from "../../common/loadingModal/loadingModal";
import DocumentUploader from "../components/documentUploader";
import ErrorCard from "views/common/error/errorCard";
import LoadingPane from "../../../controls/loadingPane";

const ExemptionView: ViewComponent<ExemptionViewModel> = observer(({ vm }) => {
  const translate = (value: string) => vm.localizationService.translateGeneral(`exemption.${value}`);
  const formRef = useCallback(node => {
    if (node !== null) {
      vm.formElement = node;
    }
  }, []);

  return (
    <>
      <View vm={vm.outagesViewModel} />
      <div className="bg-white p-3 p-lg-4 p-xl-7 rounded">
        <Form className="p-3 p-lg-4 p-xl-7" ref={formRef}>
          <ErrorCard message={vm.errorMessage} sticky={true} />
          <ExemptionNotice vm={vm} />
          {vm.loadingData && !vm.vehicleChargingInstructions && (
            <Row className="d-flex justify-content-center align-items-center pb-3 pb-lg- pb-xl-3">
              <Col sm={1} lg="auto" className="p-2 spinner-auto">
                <LoadingPane />
              </Col>
              <Col sm={4} lg="auto" className="p-2">
                <div className="d-flex justify-content-center align-items-center">{translate("loadingInstruction")}</div>
              </Col>
            </Row>
          )}
          {vm.vehicleChargingInstructions &&
            vm.vehicleChargingInstructions.warningReasons?.map(instruction => (
              <Alert key={instruction} variant="warning">
                <strong className="font-size-sm">
                  {vm.translateWarningReason(instruction, vm.vehicleChargingInstructions?.possibleExemptionReasonIds)}
                </strong>
              </Alert>
            ))}
          <View vm={vm.applicantPersonViewModel} />
          <View vm={vm.operatorInputViewModel} />
          <MethodOfSignature vm={vm} />
          <DocumentUploader vm={vm} />
          {vm.exemptionApplicationProduction &&
            vm.exemptionApplicationProduction.warningReasons?.map(instruction => (
              <Alert key={instruction} variant="warning">
                <strong className="font-size-sm">{vm.translateWarningReason(instruction)}</strong>
              </Alert>
            ))}
          <Toolbox vm={vm} />
          <LoadingModal translate={vm.translateGeneral} isVisible={vm.showLoadingModal} />
        </Form>
      </div>
    </>
  );
});

registerView(ExemptionView, ExemptionViewModel);
